
const Verbiage = {
  PICKUP_TILE_HEADING_BOPIS: "Store Pickup",
  PICKUP_TILE_HEADING_BOSS: "Ship to Store",
  PICKUP_TILE_HEADING_IN_STORE: "In-Store Purchase",
  PICKUP_TILE_MSG: "Pickup",
  PICKUP_TILE_LIMITED_STOCK: "Limited stock at",
  PICKUP_TILE_MSG_NOT_AVAIL: "Not available for this item",
  PICKUP_TILE_MSG_IN_STORE_ONLY: "This item can only be purchased in stores.",
  PICKUP_TILE_PRICE: "FREE",
  PICKUP_TILE_DATE: "Today",
  PICKUP_TILE_CHECK_NEARBY: "Check Nearby Stores",
  PICKUP_TILE_CHANGE_STORE: "Change Store",
  PICKUP_TILE_BACKORDERED: "Backordered",
  PICKUP_DETAILS_IN_STOCK: "in stock at",
  PICKUP_DETAILS_SEND: "We'll send it to",
  PICKUP_DETAILS_NOT_IN_STOCK: "Not in stock at",
  PICKUP_DETAILS_UNAVAIL: "Unavailable at",

  STH_TILE_HEADING: "Ship to Home",
  STH_TILE_MSG: "Get it by",
  STH_TILE_MSG_EXPECT_IT: "Expect it",
  STH_TILE_MSG_NOT_AVAIL: "Not available for this item",
  STH_TILE_MSG_BACKORDERED: "Backordered",
  STH_TILE_PRICE_FREE: "FREE",
  STH_TILE_PRICE_FREE_45: "Free with $45 Order",
  STH_TILE_PRICE_STD_DELIVERY: "Standard Delivery",
  STH_TILE_PRICE_OUT_OF_STOCK: "Out of Stock",
  STH_DETAILS_EXPECT_IT: "Expect it",
  STH_DETAILS_GET_IT_BY: "Get it by",
  STH_DETAILS_ORDER_WITHIN: "Order within",
  STH_DETAILS_BACKORDERED: "Backordered",

  EXPRESS_TILE_HEADING: "Express Delivery",
  EXPRESS_TILE_HEADING_COVID: "Scheduled Delivery",
  EXPRESS_TILE_MSG_TODAY: "Get it\u00a0Today",
  EXPRESS_TILE_MSG_TOMORROW: "Get it\u00a0Tomorrow",
  EXPRESS_TILE_MSG_NO_DATE: "Schedule Delivery",
  EXPRESS_TILE_MSG_NOT_AVAIL: "Not available for this item",
  EXPRESS_DETAILS_TODAY: "Get it scheduled for delivery as soon as\u00a0Today",
  EXPRESS_DETAILS_TOMORROW: "Get it scheduled for delivery as soon as\u00a0Tomorrow",
  EXPRESS_DETAILS_NO_DATE: "Schedule Express Delivery at your convenience.",

  BACKORDERED_NO_DATE_FIRST_HALF: "This item is ",
  BACKORDERED_NO_DATE_SECOND_HALF: ", but will be restocked soon. We won't charge you until it ships.",
  BACKORDERED_DATE_FIRST_HALF: "This product is currently",
  BACKORDERED_DATE_SECOND_HALF: "We won't charge you until it ships.",
  BACKORDERED_DATE_TEST: "This product is currently backordered. We won't charge you until it ships.",
  BACKORDERED_NO_DATE: "This item is backordered, but will be restocked soon. We won't charge you until it ships.",
  BACKORDERED_DATE_BOLD: " backordered. ",
  BACKORDERED: "Backordered!",
  LIVE_GOODS_OUT_OF_SEASON: "This plant is out of season.",
  LIVE_GOODS_IN_SEASON: "This plant is in season!"
};

Verbiage.getKey = (text) => {
  let key = "";
  for(const _key in Verbiage){
    if(Verbiage[_key]===text){
      key = _key
    }
  }
  return key || text;
};

export default Verbiage;
